<div class="flex flex-col justify-center w-full" *ngIf="!auth.currentUser">
  <div class="w-full text-center m-auto " style="width:304px" id="recaptcha-container" [class.hidden]="authenticationSucceed || reCaptchaSolved"></div>
</div>

